import React, { useState, useEffect, useContext } from 'react';
import { 
    Card, 
    Row, 
    Col, 
    Badge, 
    Spinner, 
    Alert, 
    Container, 
    Button, 
    Form, 
    Dropdown,
    InputGroup
} from 'react-bootstrap';
import {
    FaCalendarAlt,
    FaGraduationCap,
    FaSync,
    FaExclamationTriangle,
    FaArrowLeft,
    FaDownload,
    FaBook,
    FaListAlt,
    FaSchool,
    FaUserGraduate,
    FaChevronRight,
    FaFilter,
    FaSearch,
    FaClock,
    FaChartBar,
    FaUsers,
    FaCalendarCheck,
    FaFilePdf
} from 'react-icons/fa';
import moment from 'moment';
import { getCachedData, setCachedData } from '../utils/apiCache';
import Swal from 'sweetalert2';
import Header from './Header';
import { Link, useNavigate } from 'react-router-dom';
import { all_routes } from './router/all_routes';
import { ProductContext } from "../context/AppContext";
import { Modal } from "react-bootstrap";

const Exam = () => {
    const [sessions, setSessions] = useState([]);
    const [selectedSession, setSelectedSession] = useState(null);
    const [examData, setExamData] = useState(null);
    const [loading, setLoading] = useState(false);
    const [sessionLoading, setSessionLoading] = useState(true);
    const [error, setError] = useState(null);
    const [refreshing, setRefreshing] = useState(false);
    const [searchTerm, setSearchTerm] = useState('');
    const [StudentStoreData, setStudentStoreData] = useState('');
    const [filterType, setFilterType] = useState('all');
    const navigate = useNavigate();
    const [showMarksheetModal, setShowMarksheetModal] = useState(false);
    const [showWeightageMarksheet, setShowWeightageMarksheet] = useState(false);
    const [showNormalMarksheet, setShowNormalMarksheet] = useState(true);

    // console.log(examData, 'examData Data')

    const routes = all_routes;
    const { GetstudentData } = useContext(ProductContext);
    const clsSecId = GetstudentData?.cls_sec?.id;
    const className = GetstudentData?.cls_sec?.cls?.Classes || "";
    const sectionName = GetstudentData?.cls_sec?.section?.section || "";
    const studentId = GetstudentData?.id;

    // Fetch Sessions
    const fetchSessions = async () => {
    const authtoken = localStorage.getItem('token');
    const cacheKey = 'exam_sessions_raw';
    const cached = getCachedData(cacheKey);
    if (cached && Array.isArray(cached) && cached.length > 0) {
      setSessions(cached);
      const currentStudentSessionId = Number(GetstudentData?.session);
      const defaultSession = cached.find(s => Number(s.id) === currentStudentSessionId)
        || cached.find(s => s.Is_Current_Session === 1 || s.Is_Current_Session === true || s.is_current === 1)
        || cached[0];
      if (defaultSession) {
        setSelectedSession(defaultSession);
      }
      setSessionLoading(false);
    }
    try {
      const response = await fetch('https://api.mirai.healthcare/api/masters/session', {
        method: 'GET',
        headers: {
          'Accept': 'application/json',
          'x-auth': authtoken
        }
      });
      if (response.ok) {
        const data = await response.json();
        const rawSessions = data?.data || [];
        setSessions(rawSessions);
        setCachedData(cacheKey, rawSessions);

        const currentStudentSessionId = Number(GetstudentData?.session);
        const defaultSession = rawSessions.find(s => Number(s.id) === currentStudentSessionId)
          || rawSessions.find(s => s.Is_Current_Session === 1 || s.Is_Current_Session === true || s.is_current === 1)
          || rawSessions[0];
        if (defaultSession) {
          setSelectedSession(defaultSession);
        }
      }
    } catch (error) {
      console.error("Fetch error sessions:", error);
    } finally {
      setSessionLoading(false);
    }
  };


    // Fetch Exam Data
    const fetchExamData = async () => {
        if (!selectedSession || !clsSecId) {
            setError('Session or Class Section ID not found');
            setLoading(false);
            return;
        }

        try {
            setLoading(true);
            setError(null);

            const authtoken = localStorage.getItem('token');
            const response = await fetch(
                `https://api.mirai.healthcare/api/exam-paper-map?class_section_id=${clsSecId}&session_id=${selectedSession.id}`,
                {
                    method: 'GET',
                    headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json',
                        'x-auth': authtoken
                    }
                }
            );

            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }

            const data = await response.json();
            setExamData(data.responseData[0]);
        } catch (err) {
            console.error('Error fetching exam data:', err);
            setError(err.message || 'Failed to fetch exam data');
        } finally {
            setLoading(false);
            setRefreshing(false);
        }
    };

    
    // Handle View Marksheet
    const handleViewMarksheet = async () => {
        // if (!studentId) {
        //     Swal.fire('Error', 'Student ID not found.', 'error');
        //     return;
        // }

        try {
            const authtoken = localStorage.getItem('token');
            const response = await fetch(
                `https://api.mirai.healthcare/api/exam/publish-marksheet?student_id=${studentId}`,
                {
                    method: 'GET',
                    headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json',
                        'x-auth': authtoken
                    }
                }
            );

            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }

            const data = await response.json();
            setStudentStoreData(data);
        } catch (err) {
            console.error('Error checking marksheet:', err);
            // Swal.fire('Error', 'Failed to check marksheet status.', 'error');
        }
    };

    useEffect(() => {
        fetchSessions();
        handleViewMarksheet();
    }, []);


    // const FilterShowMarksheet = StudentStoreData?.message?.filter((item)=>
    // item?.show_marksheet === true) || [];
    //     console.log(FilterShowMarksheet, 'FilterShowMarksheet Data')



    // const FilterApprovedExam = StudentStoreData?.message?.filter((item)=>
    // item?.status === "approved") || [];

    // All approved exam types - show_marks per exam type is checked on ExamPapers page
    const ApprovedExams = StudentStoreData?.message?.filter((item)=>
    item?.status === "approved") || [];

    // Only exam types with show_marksheet: true go into the marksheet
    const FilterApprovedExam = ApprovedExams?.filter((item)=>
    item?.show_marksheet === true);

    const exam_type_ids = FilterApprovedExam?.map((item)=>item?.exam_type?.id ?? item?.exam_type_id);

    const isSkillView = FilterApprovedExam?.some((item)=>item?.is_skill_visible === true);
    const isCurriculumView = FilterApprovedExam?.some((item)=>item?.is_curr_visible === true);
    const isObservationView = FilterApprovedExam?.some((item)=>item?.is_oberv_visible === true);

    // console.log(examType, "examType Data Exam")



const examTypeLatestDates = examData?.exam_types?.map((exam) => {

  // Latest paper nikaalo
  const latestPaper = exam?.papers?.reduce((latest, current) => {
    if (!latest) return current;

    return new Date(current.exam_date) > new Date(latest.exam_date)
      ? current
      : latest;
  }, null);

  return {
    exam_type_id: exam.exam_type_id,
    latest_exam_date: latestPaper?.exam_date?.split("T")[0] || null
  };
});

const latestDate = examData?.exam_types
  ?.flatMap(exam => exam.papers)
  ?.reduce((latest, current) => {
    if (!latest) return current;

    return new Date(current.exam_date) > new Date(latest.exam_date)
      ? current
      : latest;
  }, null)?.exam_date?.split("T")[0];


//     const handleGenerateConfirm = () => {
//     navigate("/MarksheetView", {
//     state: {
//       session_id: StudentStoreData?.message[0]?.session_id,
//       student_id: StudentStoreData?.message[0]?.student_id,
//       class_section_id: StudentStoreData?.message[0]?.student?.class_section_id,
//       exam_type_ids: exam_type_ids,
//       examTypeLatestDates: examTypeLatestDates,
//       latestDate: latestDate,
//       isSkillView: isSkillView,
//       isCurriculumView: isCurriculumView,
//       isObservationView: isObservationView,
//     },
//   });
// };
const [marksheetType, setMarksheetType] = useState("weightage");

const handleGenerateConfirm = () => {
  navigate(
    marksheetType === "weightage"
      ? "/MarksheetView"
      : "/NormalMarksheet",
    {
      state: {
        session_id: StudentStoreData?.message[0]?.session_id,
        student_id: StudentStoreData?.message[0]?.student_id,
        class_section_id: StudentStoreData?.message[0]?.student?.class_section_id,
        exam_type_ids,
        examTypeLatestDates,
        latestDate,
        isSkillView,
        isCurriculumView,
        isObservationView,
      },
    }
  );

  setShowMarksheetModal(false);
};

    useEffect(() => {
        if (selectedSession) {
            fetchExamData();
        }
    }, [selectedSession, clsSecId]);

    useEffect(() => {
        if (sessions.length > 0 && !selectedSession) {
            const currentStudentSessionId = Number(GetstudentData?.session);
            const defaultSession = sessions.find(s => Number(s.id) === currentStudentSessionId)
                || sessions.find(s => s.Is_Current_Session === 1 || s.Is_Current_Session === true || s.is_current === 1)
                || sessions[0];
            if (defaultSession) {
                setSelectedSession(defaultSession);
            }
        }
    }, [GetstudentData, sessions, selectedSession]);


    // Handle Session Change
    const handleSessionChange = (session) => {
        setSelectedSession(session);
    };

    // Handle Exam Type Click
    const handleExamTypeClick = (examType) => {
        navigate('/exam-papers', { 
            state: { 
                examType,
                session: selectedSession,
                className,
                sectionName,
                ApprovedExams,
                // start_time,
                // end_time

            }
        });
    };



    // Refresh Function
    const handleRefresh = () => {
        setRefreshing(true);
        fetchExamData();

        setTimeout(() => {
            Swal.fire({
                icon: 'success',
                title: 'Refreshed',
                text: 'Exam data has been refreshed successfully.',
                confirmButtonText: 'OK',
                confirmButtonColor: '#17a2b8',
                timer: 2000,
                showConfirmButton: false
            });
        }, 500);
    };

    // Back Function
    const handleBack = () => {
        window.history.back();
    };

    const formatDate = (dateString) => {
        return moment(dateString, 'DD-MM-YYYY').format('DD MMMM YYYY');
    };

    const getTotalPapers = () => {
        if (!examData?.exam_types) return 0;
        return examData.exam_types.reduce((total, exam) => total + exam.papers.length, 0);
    };

    const getUpcomingExams = () => {
        if (!examData?.exam_types) return 0;
        const today = moment().startOf('day');
        let count = 0;
        
        examData.exam_types.forEach(exam => {
            exam.papers.forEach(paper => {
                if (moment(paper.exam_date).isSameOrAfter(today)) {
                    count++;
                }
            });
        });
        
        return count;
    };

    const getFilteredExamTypes = () => {
        if (!examData?.exam_types) return [];

        let filtered = examData.exam_types;

        // Apply search filter
        if (searchTerm) {
            filtered = filtered.filter(exam => 
                exam.exam_type_name.toLowerCase().includes(searchTerm.toLowerCase()) ||
                exam.exam_type_title.toLowerCase().includes(searchTerm.toLowerCase())
            );
        }

        // Apply type filter
        if (filterType === 'with_papers') {
            filtered = filtered.filter(exam => exam.papers.length > 0);
        } else if (filterType === 'without_papers') {
            filtered = filtered.filter(exam => exam.papers.length === 0);
        }

        return filtered;
    };

    const filteredExamTypes = getFilteredExamTypes();

    const StatCard = ({ icon: Icon, title, value, subtitle, color = 'primary' }) => (
        <Card className="stat-card border-0 h-100 shadow-sm">
            <Card.Body className="p-3">
                <div className="d-flex align-items-center">
                    <div className={`icon-container bg-${color} me-3 flex-shrink-0`}>
                        <Icon size={20} className="text-white" />
                    </div>
                    <div className="flex-grow-1">
                        <h6 className="text-muted mb-1 small">{title}</h6>
                        <h4 className="fw-bold text-dark mb-0">{value}</h4>
                        {subtitle && <small className="text-muted">{subtitle}</small>}
                    </div>
                </div>
            </Card.Body>
        </Card>
    );

    const ExamTypeCard = ({ examType, index }) => {
        const totalWeightage = examType.papers.reduce((sum, paper) => sum + paper.weightage, 0);
        const hasUpcomingExams = examType.papers.some(paper => 
            moment(paper.exam_date).isSameOrAfter(moment().startOf('day'))
        );

        return (
            <Col xl={4} lg={6} md={6} className="mb-4">
                <Card className="exam-type-card border-0 shadow-sm h-100">
                    <Card.Body className="p-4">
                        {/* Header Section */}
                        <div className="d-flex align-items-start justify-content-between mb-3">
                            <div className="exam-type-icon bg-primary text-white rounded-circle d-flex align-items-center justify-content-center">
                                <FaBook size={16} />
                            </div>
                            <div className="d-flex gap-2">
                                <Badge bg={hasUpcomingExams ? "warning" : "secondary"} className="exam-status-badge">
                                    {hasUpcomingExams ? 'Upcoming' : 'Completed'}
                                </Badge>
                                {/* <Badge bg="light" text="dark" className="papers-count">
                                    {examType.papers.length}
                                </Badge> */}
                            </div>
                        </div>

                        {/* Exam Info */}
                        <div className="exam-info mb-3">
                            <h5 className="fw-bold text-dark mb-2 exam-name">{examType.exam_type_name}</h5>
                            <p className="text-muted mb-3 exam-title">{examType.exam_type_title}</p>
                            {/* <p className="text-muted mb-3 exam-title">{examType.papers?.start_time}</p>
                            <p className="text-muted mb-3 exam-title">{examType.end_time}</p> */}
                        </div>

                        {/* Action Button */}
                        <Button
                            variant="primary"
                            className="w-100 view-details-btn"
                            onClick={() => handleExamTypeClick(examType)}
                            disabled={examType.papers.length === 0}
                        >
                            {examType.papers.length === 0 ? (
                                'No Papers Available'
                            ) : (
                                <>
                                    View Details
                                    <FaChevronRight className="ms-2" size={14} />
                                </>
                            )}
                        </Button>
                    </Card.Body>
                </Card>
            </Col>
        );
    };

    if (sessionLoading) {
        return (
            <div className="page-wrapper">
                <div className="content">
                    <Header />
                    <Container className="py-5">
                        <div className="text-center py-5">
                            <div className="loading-spinner">
                                <FaGraduationCap size={48} className="text-primary mb-3" />
                                <Spinner animation="border" variant="primary" className="mb-3" />
                                <h5 className="text-dark">Loading Sessions</h5>
                                <p className="text-muted">Fetching academic sessions...</p>
                            </div>
                        </div>
                    </Container>
                </div>
            </div>
        );
    }

    return (
        <div className="page-wrapper">
            <div className="content">
                <Header />
                <Container fluid className="py-4">
                    {/* Header Section */}
                    <Row className="align-items-center mb-4">
                        <Col>
                            <div className="d-flex align-items-center">
                                <div className="bg-primary rounded-3 p-3 me-3">
                                    <FaGraduationCap className="text-white fs-2" />
                                </div>
                                <div>
                                    <h2
              className="page-title mb-1 w-bold mb-0"
              style={{ letterSpacing: "0.5px" }}>Exams & Assessments</h2>
                                    <p className="text-muted mb-0">View upcoming exams and published results for {className} - {sectionName}</p>
                                </div>
                            </div>
                        </Col>
                        <Col xs="auto" className="d-flex gap-2">
                            <Button variant="outline-primary" className="rounded-pill px-4" onClick={handleBack}>
                                <FaArrowLeft className="me-2" />
                                Back
                            </Button>
                            {/* {FilterApprovedExam?.length > 0 && ( */}
                            

{FilterApprovedExam?.length > 0 && (
    <Button
        variant="success"
        className="rounded-pill px-4"
        // onClick={handleGenerateConfirm}
        onClick={() => setShowMarksheetModal(true)}
    >
        <FaFilePdf className="me-2" />
        View Marksheet
    </Button>
)}
                            
                             {/* )} */}
                        </Col>
                    </Row>

                    {error && (
                        <Alert variant="danger" className="border-0 shadow-sm mb-4">
                            <div className="d-flex align-items-center">
                                <FaExclamationTriangle className="me-3 fs-4 text-danger" />
                                <div className="flex-grow-1">
                                    <h6 className="alert-heading mb-1">Error Loading Data</h6>
                                    <p className="mb-2">{error}</p>
                                    <Button variant="outline-danger" size="sm" onClick={fetchExamData}>
                                        <FaSync className="me-1" />
                                        Try Again
                                    </Button>
                                </div>
                            </div>
                        </Alert>
                    )}

                    {/* Stats Cards */}
                    <Row className="mb-4">
                        <Col md={4} className="mb-3">
                            <StatCard
                                icon={FaBook}
                                title="Exam Types"
                                value={examData?.exam_types?.length || 0}
                                subtitle="Total exams scheduled"
                                color="primary"
                            />
                        </Col>
                        {/* <Col md={3} className="mb-3">
                            <StatCard
                                icon={FaListAlt}
                                title="Total Papers"
                                value={getTotalPapers()}
                                subtitle="Across all exams"
                                color="info"
                            />
                        </Col> */}
                        <Col md={4} className="mb-3">
                            <StatCard
                                icon={FaCalendarCheck}
                                title="Upcoming"
                                value={getUpcomingExams()}
                                subtitle="Exams starting soon"
                                color="warning"
                            />
                        </Col>
                        <Col md={4} className="mb-3">
                            <StatCard
                                icon={FaUsers}
                                title="Session"
                                value={selectedSession?.Name || 'N/A'}
                                subtitle="Current academic year"
                                color="success"
                            />
                        </Col>
                    </Row>

                    {/* Session Selector */}
                    {selectedSession && (
                        <Card className="border-0 shadow-sm mb-4">
                            <Card.Body className="session-selector">
                                <Row className="align-items-center">
                                    <Col md={8}>
                                        <div className="d-flex align-items-center">
                                            <FaCalendarAlt className="me-3 text-primary fs-4" />
                                            <div>
                                                <h6 className="mb-1 fw-bold">Current Session</h6>
                                                <p className="text-muted mb-0 small">{selectedSession.Name} ({formatDate(selectedSession.Start_Date)} - {formatDate(selectedSession.End_Date)})</p>
                                            </div>
                                        </div>
                                    </Col>
                                    <Col md={4} className="text-md-end">
                                        <Dropdown>
                                            <Dropdown.Toggle variant="outline-primary" id="session-dropdown" className="session-dropdown w-100">
                                                {selectedSession.Name}
                                            </Dropdown.Toggle>
                                            <Dropdown.Menu className="session-menu w-100">
                                                {sessions.map((session) => (
                                                    <Dropdown.Item
                                                        key={session.id}
                                                        className="session-item"
                                                        onClick={() => handleSessionChange(session)}
                                                        active={selectedSession.id === session.id}
                                                    >
                                                        <div className="session-item-name fw-semibold">{session.Name}</div>
                                                        <div className="session-dates text-muted small">
                                                            {formatDate(session.Start_Date)} - {formatDate(session.End_Date)}
                                                        </div>
                                                        {session.Is_Current_Session && (
                                                            <Badge bg="success" className="current-badge mt-1">Current</Badge>
                                                        )}
                                                    </Dropdown.Item>
                                                ))}
                                            </Dropdown.Menu>
                                        </Dropdown>
                                    </Col>
                                </Row>
                            </Card.Body>
                        </Card>
                    )}

                    {/* Filters */}
                    {!loading && examData && (
                        <Card className="border-0 shadow-sm mb-4">
                            <Card.Body className="p-4">
                                <Row className="g-3 align-items-end">
                                    <Col md={6} lg={4}>
                                        <div className="search-group" style={{display:'inline-flex',width:'100%'}}>
                                            <InputGroup.Text className="bg-light border-end-0">
                                                <FaSearch className="text-muted" />
                                            </InputGroup.Text>
                                            <Form.Control
                                                type="text"
                                                placeholder="Search exam types..."
                                                value={searchTerm}
                                                onChange={(e) => setSearchTerm(e.target.value)}
                                                className="border-start-0"
                                            />
                                        </div>
                                    </Col>
                                    <Col md={6} lg={4}>
                                        <Form.Select 
                                            value={filterType}
                                            onChange={(e) => setFilterType(e.target.value)}
                                            className="filter-select"
                                        >
                                            <option value="all">All Exam Types</option>
                                            <option value="with_papers">With Papers</option>
                                            <option value="without_papers">Without Papers</option>
                                        </Form.Select>
                                    </Col>
                                    <Col lg={4} className="mt-2 mt-lg-0">
                                        <div className="d-flex justify-content-lg-end">
                                            <Badge bg="light" text="dark" className="results-badge">
                                                Showing {filteredExamTypes.length} of {examData.exam_types.length} exam types
                                            </Badge>
                                        </div>
                                    </Col>
                                </Row>
                            </Card.Body>
                        </Card>
                    )}

                    {/* Main Content */}
                    {loading ? (
                        <div className="text-center py-5">
                            <div className="loading-spinner">
                                <Spinner animation="border" variant="primary" className="mb-3" />
                                <h5 className="text-dark">Loading Exam Data</h5>
                                <p className="text-muted">Fetching exam types and papers...</p>
                            </div>
                        </div>
                    ) : error ? (
                        <div className="error-state text-center py-5">
                            <FaExclamationTriangle size={64} className="text-danger mb-3 opacity-50" />
                            <h4 className="text-dark mb-3">Unable to Load Exam Data</h4>
                            <p className="text-muted mb-4">{error}</p>
                            <div className="d-flex gap-2 justify-content-center flex-wrap">
                                <Button variant="primary" onClick={fetchExamData}>
                                    <FaSync className="me-2" />
                                    Try Again
                                </Button>
                                <Button variant="outline-secondary" onClick={handleBack}>
                                    <FaArrowLeft className="me-2" />
                                    Go Back
                                </Button>
                            </div>
                        </div>
                    ) : filteredExamTypes.length > 0 ? (
                        <div>
                            <div className="d-flex justify-content-between align-items-center mb-3">
                                <h5 className="text-dark mb-0">
                                    <FaListAlt className="me-2 text-primary" />
                                    Available Exam Types
                                </h5>
                                <Badge bg="primary" className="exam-types-count">
                                    {filteredExamTypes.length} Exam Types
                                </Badge>
                            </div>
                            <Row>
                                {filteredExamTypes.map((examType, index) => (
                                    <ExamTypeCard key={examType.exam_type_id} examType={examType} index={index} />
                                ))}
                            </Row>
                        </div>
                    ) : (
                        <div className="text-center py-5 empty-state">
                            <FaBook size={64} className="text-muted mb-3 opacity-50" />
                            <h4 className="text-dark mb-3">No Exam Types Found</h4>
                            <p className="text-muted mb-4">
                                {searchTerm || filterType !== 'all' 
                                    ? 'No exam types match your search criteria. Try adjusting your filters.'
                                    : `No exam types found for ${className} - ${sectionName} in ${selectedSession?.Name} session.`
                                }
                            </p>
                            {(searchTerm || filterType !== 'all') && (
                                <Button 
                                    variant="outline-primary" 
                                    onClick={() => {
                                        setSearchTerm('');
                                        setFilterType('all');
                                    }}
                                >
                                    Clear Filters
                                </Button>
                            )}
                        </div>
                    )}
                </Container>
                <Modal
    show={showMarksheetModal}
    onHide={() => setShowMarksheetModal(false)}
    centered
    size="md"
>
    <Modal.Body className="p-0">
        {/* Header */}
        <div
            className="text-white p-4"
            style={{
                background: "linear-gradient(135deg, #4F46E5, #7C3AED)",
                borderRadius: "8px 8px 0 0"
            }}
        >
            <div className="d-flex align-items-center">
                <div
                    className="bg-white bg-opacity-25 rounded-circle d-flex align-items-center justify-content-center"
                    style={{ width: 50, height: 50 }}
                >
                    <FaFilePdf size={24} />
                </div>

                <div className="ms-3">
                    <h4 className="mb-1 text-white fw-bold">View Marksheet</h4>
                    <p className="mb-0 opacity-75">
                        Select marksheet format
                    </p>
                </div>
            </div>
        </div>

        {/* Options */}
        <div className="p-4">

            <div
                className={`marksheet-option-card mb-3 ${
                    marksheetType === "weightage" ? "active-option" : ""
                }`}
                onClick={() => setMarksheetType("weightage")}
            >
                <div className="d-flex align-items-center justify-content-between">
                    <div className="d-flex align-items-center">
                        <div className="option-icon bg-primary-subtle">
                            📊
                        </div>

                        <div className="ms-3">
                            <h6 className="mb-1 fw-bold">
                                Weightage Marksheet
                            </h6>
                            <small className="text-muted">
                                Detailed marks with weightage calculation
                            </small>
                        </div>
                    </div>

                    <Form.Check
                        type="radio"
                        checked={marksheetType === "weightage"}
                        readOnly
                    />
                </div>
            </div>

            <div
                className={`marksheet-option-card ${
                    marksheetType === "normal" ? "active-option" : ""
                }`}
                onClick={() => setMarksheetType("normal")}
            >
                <div className="d-flex align-items-center justify-content-between">
                    <div className="d-flex align-items-center">
                        <div className="option-icon bg-success-subtle">
                            📄
                        </div>

                        <div className="ms-3">
                            <h6 className="mb-1 fw-bold">
                                Normal Marksheet
                            </h6>
                            <small className="text-muted">
                                Standard student marksheet view
                            </small>
                        </div>
                    </div>

                    <Form.Check
                        type="radio"
                        checked={marksheetType === "normal"}
                        readOnly
                    />
                </div>
            </div>

            {/* Buttons */}
            <div className="d-flex justify-content-end mt-4">
                <Button
                    variant="light"
                    className="me-2 px-4"
                    onClick={() => setShowMarksheetModal(false)}
                >
                    Cancel
                </Button>

                <Button
                    className="px-4"
                    style={{
                        background:
                            "linear-gradient(135deg,#4F46E5,#7C3AED)",
                        border: "none"
                    }}
                    onClick={handleGenerateConfirm}
                >
                    Continue →
                </Button>
            </div>
        </div>
    </Modal.Body>
</Modal>
            </div>

            <style jsx>{`
.exam-management-wrapper {
    min-height: 100vh;
}

.page-header-simple {
    background: #ffffff;
    border: 1px solid #e9ecef;
    padding: 1.5rem;
    border-radius: 8px;
    margin-bottom: 2rem;
    box-shadow: 0 1px 3px rgba(0,0,0,0.1);
}

.simple-breadcrumb {
    background: transparent;
    padding: 0;
    margin-bottom: 0;
}

.simple-breadcrumb .breadcrumb-item a {
    color: #6c757d !important;
    font-size: 0.875rem;
    text-decoration: none;
}

.simple-breadcrumb .breadcrumb-item.active {
    color: #495057 !important;
    font-weight: 500;
}

.simple-breadcrumb .breadcrumb-item + .breadcrumb-item::before {
    color: #6c757d;
    content: "/";
    padding: 0 0.5rem;
}

.header-icon-simple {
    background: #f8f9fa;
    padding: 0.75rem;
    border-radius: 8px;
    display: flex;
    align-items: center;
    justify-content: center;
    border: 1px solid #e9ecef;
}

.page-title-simple {
    font-size: 1.5rem;
    font-weight: 600;
    margin: 0;
    color: #212529;
    line-height: 1.2;
}

.action-buttons {
    flex-shrink: 0;
}

.btn-action {
    border-radius: 6px;
    padding: 0.5rem 1rem;
    font-weight: 500;
    font-size: 0.875rem;
    border: 1px solid;
    transition: all 0.2s ease;
    white-space: nowrap;
}

.btn-action:hover {
    transform: translateY(-1px);
    box-shadow: 0 2px 4px rgba(0,0,0,0.1);
}

.session-selector {
    background: #f8f9fa;
    padding: 1.5rem;
    border-radius: 8px;
    border: 1px solid #e9ecef;
}

.session-dropdown {
    border-radius: 6px;
    padding: 0.75rem 1rem;
}

.session-menu {
    border-radius: 8px;
    border: 1px solid #e9ecef;
    box-shadow: 0 4px 12px rgba(0,0,0,0.1);
}

.session-item {
    padding: 0.75rem 1rem;
    border-bottom: 1px solid #f8f9fa;
    transition: background-color 0.2s ease;
}

.session-item:last-child {
    border-bottom: none;
}

.session-item:hover {
    background-color: #f8f9fa;
}

.session-item-name {
    font-size: 0.9rem;
}

.session-dates {
    font-size: 0.8rem;
}

.current-badge, .current-indicator {
    font-size: 0.7rem;
}

.session-info {
    padding: 0.5rem 0;
}

.session-details {
    padding: 0.5rem 0;
}

.status-badge {
    font-size: 0.75rem;
}

.stat-card {
    border-radius: 8px;
    transition: all 0.3s ease;
}

.stat-card:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(0,0,0,0.1) !important;
}

.icon-container {
    width: 40px;
    height: 40px;
    border-radius: 8px;
    display: flex;
    align-items: center;
    justify-content: center;
}

.modern-card {
    border-radius: 8px;
    overflow: hidden;
}

.search-group .form-control {
    border-radius: 0 6px 6px 0;
}

.search-group .input-group-text {
    border-radius: 6px 0 0 6px;
}

.filter-select {
    border-radius: 6px;
}

.results-badge {
    font-size: 0.875rem;
    padding: 0.5rem 1rem;
}

.exam-types-count {
    font-size: 0.875rem;
    padding: 0.5rem 1rem;
}

/* Exam Type Card Styles */
.exam-type-card {
    border-radius: 12px;
    transition: all 0.3s ease;
    border: 1px solid #e9ecef;
}

.exam-type-card:hover {
    transform: translateY(-4px);
    box-shadow: 0 8px 25px rgba(0,0,0,0.15) !important;
    border-color: #007bff;
}

.exam-type-icon {
    width: 48px;
    height: 48px;
    flex-shrink: 0;
}

.exam-status-badge {
    font-size: 0.7rem;
    padding: 0.3rem 0.6rem;
}

.papers-count {
    font-size: 0.8rem;
    padding: 0.3rem 0.6rem;
}

.exam-name {
    font-size: 1.1rem;
    line-height: 1.3;
}

.exam-title {
    font-size: 0.9rem;
    line-height: 1.4;
    min-height: 2.8rem;
}

.exam-stats {
    background: #f8f9fa;
    padding: 1rem;
    border-radius: 8px;
}

.weightage-badge {
    font-size: 0.8rem;
    padding: 0.3rem 0.6rem;
}

.view-details-btn {
    border-radius: 8px;
    padding: 0.75rem;
    font-weight: 600;
    transition: all 0.3s ease;
}

.view-details-btn:not(:disabled):hover {
    transform: translateX(2px);
    box-shadow: 0 4px 12px rgba(0,123,255,0.3);
}

.view-details-btn:disabled {
    background-color: #6c757d;
    border-color: #6c757d;
    opacity: 0.6;
}

.loading-spinner {
    max-width: 400px;
    margin: 0 auto;
}

.error-state {
    max-width: 500px;
    margin: 0 auto;
}

.empty-state {
    background: #f8f9fa;
    border-radius: 12px;
    padding: 3rem 2rem;
}

/* Responsive Design */
@media (max-width: 768px) {
    .page-header-simple {
        padding: 1.25rem;
    }

    .page-title-simple {
        font-size: 1.25rem;
    }

    .d-flex.flex-column.flex-md-row {
        gap: 1rem !important;
    }

    .action-buttons {
        width: 100%;
        justify-content: center;
        margin-top: 1rem;
    }

    .btn-action {
        flex: 1;
        min-width: 0;
        padding: 0.5rem 0.75rem;
    }

    .session-selector {
        padding: 1rem;
    }

    .session-details {
        flex-direction: column;
        gap: 0.5rem !important;
        margin-top: 1rem;
    }

    .exam-type-card {
        margin-bottom: 1rem;
    }

    .exam-name {
        font-size: 1rem;
    }

    .exam-title {
        font-size: 0.85rem;
        min-height: auto;
    }
}

@media (max-width: 576px) {
    .page-header-simple {
        padding: 1rem;
    }

    .page-title-simple {
        font-size: 1.125rem;
    }

    .header-icon-simple {
        padding: 0.5rem;
    }

    .header-icon-simple svg {
        size: 20px;
    }

    .action-buttons {
        flex-wrap: wrap;
    }

    .btn-action {
        flex: 0 0 calc(50% - 0.25rem);
        margin-bottom: 0.5rem;
    }

    .session-dropdown {
        font-size: 0.875rem;
    }

    .stat-card .icon-container {
        width: 35px;
        height: 35px;
    }

    .stat-card h4 {
        font-size: 1.25rem;
    }

    .exam-type-icon {
        width: 40px;
        height: 40px;
    }

    .view-details-btn {
        font-size: 0.875rem;
        padding: 0.6rem;
    }
}

@media (max-width: 400px) {
    .exam-stats {
        padding: 0.75rem;
    }

    .exam-stats .d-flex {
        font-size: 0.8rem;
    }

    .papers-count, .exam-status-badge {
        font-size: 0.65rem;
    }

    .session-item {
        padding: 0.5rem 0.75rem;
    }

    .session-item-name {
        font-size: 0.8rem;
    }

    .session-dates {
        font-size: 0.7rem;
    }
}

/* Print Styles */
@media print {
    .action-buttons,
    .btn-action,
    .session-selector,
    .search-group,
    .filter-select {
        display: none !important;
    }

    .page-header-simple {
        box-shadow: none !important;
        border: 1px solid #000 !important;
    }

    .exam-type-card {
        break-inside: avoid;
        box-shadow: none !important;
        border: 1px solid #000 !important;
    }
}
`}</style>
        </div>
    );
};

export default Exam;